import React, {Component} from 'react';
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  FormFeedback, Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from "reactstrap";
import {Helmet} from "react-helmet";
import * as Yup from "yup";
import {Field, Form, Formik} from "formik";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
// import {setAccessToken} from "../../../utils/MyApi";
import {forget} from "../AuthAPI";
import {setUser} from "../../../redux/actions/action.user";
import MyAlert from "../../../utils/MyAlert";
import lang from "./lang"

class Forget extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    let apiToken = localStorage.getItem('apiToken');
    if (apiToken !== null) {
      this.props.history.push('/dashboard')
    }

    this.state = {
      alert: false,
      alertMessage: "",
      alertColor: "danger"
    }


  }


  async sendPassword(payload, reset) {

    let response = await forget(payload);

    if (response.status === 200) {
      let data = response.data;


        this.setState({
          alert: true,
          alertColor: "success",
          alertMessage: data.message,
          alertId: new Date().getTime(),
          btnDisabled: false
        });

        reset();
        //this.props.history.push('/login')
    } else{

      this.setState({
        alert: true,
        alertColor: "danger",
        alertMessage: response.data.message,
        alertId: new Date().getTime(),
        btnDisabled: false
      });

    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }


  render() {
    return (
      <div className="app flex-row align-items-center bg-login">
        <Helmet>
          <title>{lang.forget}</title>
        </Helmet>
        <MyAlert
          alertId={this.state.alertId}
          message={this.state.alertMessage}
          color={this.state.alertColor}
          show={this.state.alert}/>
        <Container>
          <Row className="justify-content-center">
            <Col md="5">
              <CardGroup>
                <Card className="p-4 bg-login-box">
                  <CardBody>
                    <Formik
                      initialValues={{
                        mobile: "",
                      }}
                      validationSchema={Yup.object().shape({
                        mobile: Yup.string()
                          .required(lang.enterMobile),

                      })}
                      onSubmit={(values, {resetForm}) => {
                        this.sendPassword(values, resetForm)
                      }}>
                      {({errors, touched}) => (
                        <Form>
                          <h1 style={{fontSize:"20px"}}>{lang.forget} </h1>
                          <p className="text-muted">{lang.forgetCm}</p>
                          <InputGroup className="mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="icon-screen-smartphone"></i>
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input type="text"
                                   name="mobile"
                                   placeholder={lang.mobile}
                                   tag={Field}
                                   invalid={errors.mobile && touched.mobile}
                            />
                            <FormFeedback>{errors.mobile}</FormFeedback>
                          </InputGroup>
                          <Row>
                            <Col xs="12" md="5">
                              <Button color="primary" className="login-btn btn-square">{lang.send}</Button>
                            </Col>
                            <Col xs="12" md="7" className="text-forget ">
                              <Link color="link" className="px-0 mt-2" to={"/login"}>{lang.login}</Link>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}


const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUser: (info) => {
      dispatch(setUser(info));
    }
  };
};
const mapStateToProps = state => {
  return {
    user: state.user
  };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Forget));

